import { useState } from "react";
import fetch from "isomorphic-fetch";
import API_URL from "helpers/apiURL";

import Header from "components/organisms/header/";
import Button from "components/atoms/button";
import FormActions from "components/molecules/formActions";
import FormContent from "components/organisms/formContent";
import FormCol from "components/molecules/formCol";
import FormFieldset from "components/molecules/formFieldset/";
import FormTextField from "components/molecules/formTextField/";
import FormTextFieldLegend from "components/atoms/formFieldsetLegend/";
import FormTextArea from "components/molecules/formTextArea/";

export const Siniestro = () => {
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [data, setData] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    setSubmitting(true);

    try {
      const response = await fetch(`${API_URL}/accident`, {
        method: "POST",
        body: formData,
      });

      setData(await response.json());

      setSuccess(true);
    } catch (error) {
      setSuccess(false);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div className="personalInfo">
      <Header inFlow />
      <section className="stepContent">
        <div className="container">
          <div className="col">
            <h2>Reportar siniestro</h2>
            <p className="b">
              Si tu solicitud corresponde a un siniestro, por favor completá el siguiente
              formulario.
            </p>
            <Button
              to="/chevrolet"
              variant="secondary"
              buttonText="Volver a turnos"
            />
            {success && (
              <p className="b">
                <br />
                <strong>Solicitud recibida con número de referencia {data?.data?.id}. Te estaremos contactando en breve.</strong>
              </p>
            )}
            {!success && (
              <form className="validated-form" onSubmit={handleSubmit}>
                <FormContent nomargins>
                  <FormFieldset divider>
                    <FormCol single>
                      <FormTextFieldLegend>Datos personales</FormTextFieldLegend>
                      <div className="fieldGroup">
                        <FormTextField
                          name="name"
                          label="Nombre"
                          type="text"
                          inline
                          size="m"
                          required
                        />
                        <FormTextField
                          name="lastname"
                          label="Apellido"
                          type="text"
                          inline
                          size="m"
                          required
                        />
                      </div>
                      <FormTextField
                          name="dni"
                          label="DNI"
                          type="text"
                          inline
                          size="m"
                        />
                      <FormTextField name="company" label="Razón social" type="text" size="b" />
                      <div className="fieldGroup">
                        <FormTextField
                          name="cellphone"
                          label="Número de teléfono"
                          type="text"
                          inline
                          size="m"
                          required
                        />
                        <FormTextField
                          name="license_plate"
                          label="Patente"
                          type="text"
                          inline
                          size="m"
                          required
                        />
                      </div>
                      <FormTextField name="email" label="Email" type="email" size="b" required />
                      <FormTextField
                        name="insurer"
                        label="Compañía de seguros"
                        type="text"
                        size="b"
                      />
                      <FormTextField
                        name="insurer_data"
                        label="Número de póliza/reclamo/siniestro"
                        type="text"
                        size="b"
                      />
                      <FormTextArea
                        last
                        label="Comentarios"
                        placeholder="Comentarios"
                        nolabel
                        name="comments"
                        size="small"
                      />
                      <FormTextField
                        name="images[]"
                        label="Adjuntar fotos"
                        type="file"
                        multiple
                        accept="image/*"
                        size="b"
                      />
                    </FormCol>
                  </FormFieldset>
                  <FormActions>
                    {!submitting && (
                      <Button type="submit" buttonText="Enviar" />
                    )}
                    {submitting && <div>Enviando...</div>}
                  </FormActions>
                </FormContent>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};
